/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as o from "react";
import { provideLocalizationService as r, registerForLocalization as n } from "@progress/kendo-react-intl";
import { clear as t, messages as a } from "../messages/index.mjs";
import { IconWrap as s } from "@progress/kendo-react-common";
import { xIcon as i } from "@progress/kendo-svg-icons";
class c extends o.Component {
  constructor() {
    super(...arguments), this.onMouseDown = (e) => e.preventDefault();
  }
  render() {
    const e = r(this).toLanguageString(t, a[t]);
    return /* @__PURE__ */ o.createElement(
      "span",
      {
        className: "k-clear-value",
        role: "button",
        onClick: this.props.onClick,
        onMouseDown: this.onMouseDown,
        tabIndex: -1,
        title: e,
        key: "clearbutton"
      },
      /* @__PURE__ */ o.createElement(s, { name: "x", icon: i })
    );
  }
}
n(c);
export {
  c as default
};
